import React from 'react'
import styled from 'styled-components'

import { theme } from '@/theme'

const SupportSection = styled.div`
  background-color: ${theme.colors.lightBg};
  border-radius: 1rem;
  padding: 1.5rem;
  text-align: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
`

const SupportText = styled.p`
  font-size: 0.875rem;
  color: ${theme.colors.greyText};
  line-height: normal;
`

const SupportLink = styled.a`
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`

export const AssistanceSection = () => (
  <SupportSection>
    <SupportText>
      Need assistance?
      <br />
      Email{' '}
      <SupportLink href="mailto:support@altovita.com">
        support@altovita.com
      </SupportLink>
    </SupportText>
  </SupportSection>
)
